// import Button from "@surgia/ui/components/button";
export interface IWrongPortalProps {
  title: string;
  children: React.ReactNode;
  // buttonText: string;
  // onClick: () => void;
}

function WrongPortal({
  title,
  children,
  // buttonText,
  // onClick,
}: IWrongPortalProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        <h1 className="page-title mb-4">{title}</h1>
        <p className="text-gray-600 mb-6">{children}</p>
        {/* <Button onClick={onClick} variant="purple">
          {buttonText}
        </Button> */}
      </div>
    </div>
  );
}

export default WrongPortal;
